export const LEVELS = {
  HEIGHT: 'HIGHT',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW',
};
